import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { AuthService } from '../../core/auth/auth.service';
import { SessionTimerService } from './session-counter.service';

@Component({
  selector: 'app-session-counter',
  templateUrl: './session-counter.component.html',
  standalone: true,
  imports: [],
  styleUrls: ['./session-counter.component.scss']
})
export class SessionCounterComponent implements OnInit, OnDestroy {
  timeLeftFormatted: string = '00:00:00';
  private destroy$ = new Subject<void>();

  constructor(private authService: AuthService, private sessionTimerService: SessionTimerService) {}

  ngOnInit() {
    this.startTimer();
  }

  startTimer() {
    this.sessionTimerService.startTimer(); //init expiresAt
    this.sessionTimerService.timeLeft$.pipe(
      takeUntil(this.destroy$),
      tap((timeLeft)=>{
        this.timeLeftFormatted = this.formatTimeLeft(timeLeft); //format timeLeft
      })
    ).subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  formatTimeLeft(millis: number): string {
    if (millis <= 0) {
      return '00:00:00';
    }
    
    const totalSeconds = Math.floor(millis / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const formattedSeconds = String(seconds).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedHours = String(hours).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }
}
